import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrendTile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <rect
      width={11.25}
      height={4.219}
      x={2.125}
      y={4}
      fill="#E0E3E9"
      rx={1.375}
    />
    <path
      fill="url(#TrendTile_svg__a)"
      d="M2 26v-6.955c2.593.258 9.054-.309 14.146-4.636C21.24 10.082 28.171 9 31 9v17z"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M31 9a1 1 0 0 0-1-1c-3.264 0-5.654.488-7.94 1.49-2.226.977-4.32 2.431-6.967 4.27l-.063.044C9.818 17.423 5.523 18 3 18a1 1 0 1 0 0 2c2.877 0 7.582-.673 13.17-4.554 2.723-1.89 4.664-3.233 6.694-4.124C24.854 10.449 26.964 10 30 10a1 1 0 0 0 1-1"
      clipRule="evenodd"
    />
    <path
      fill="#949EB2"
      d="M16.367 5.21a.29.29 0 0 1 .483 0l.924 1.4a.29.29 0 0 1-.242.449h-1.847a.29.29 0 0 1-.242-.45l.924-1.4Z"
    />
    <defs>
      <linearGradient
        id="TrendTile_svg__a"
        x1={19}
        x2={18.674}
        y1={12.5}
        y2={26.492}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" stopOpacity={0.3} />
        <stop offset={1} stopColor="#C8D9FC" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgTrendTile;
